

<template>
	<div class="back-button">
		<a @click="onClick" class="link px-9 px-md-5 py-2 mb-2 mb-md-5" :class="{disabled:disabled}">
			<i class="fas fa-arrow-left"></i>
		</a>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js';
import { mapState } from 'vuex';
import { Navigation } from '@/services/navigation.service'

export default {
	props: ['disabled', 'link', 'index', 'node'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('navigation', ['current']),
		isCurrent() {
			return this.current.url == this.link
		}
	},
	methods: {
		onClick() {
			Navigation.back();
		}
	}

}
</script>

<style scoped lang="scss">
		
	.back-button {
		white-space: nowrap;
		.link {
			color: #f6ffff;
			font: 1.5rem/1 $font-condensed;
			font-weight: 600;
			letter-spacing: 0.02em;
			text-transform: uppercase;
			display: inline-block;
			position: relative;
			transform: skewY(-26deg) scaleX(0.9) translate(-35px, 95px);
			transform-origin: top left;
			transition: 0.2s all;
			cursor: pointer;
			user-select: none;
			@media ($min-device-width-md) {
				font-size: 2.5rem;
			}
		}
		&:hover {
			.link {
				color: #009e92;
			}
		}
	}

	.pflege .back-button {
		&:hover .link {
			color: #1b9fcc;
		}
	}

</style>
